
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/product",
      function () {
        return require("private-next-pages/shop/product.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/product"])
      });
    }
  